
import './OpeningHoursPolicies.css';
import {
  useEffect,
  useState,
  Locale,
  Select,
  PropTypes,
} from '../../../libraries/index';
import { CustomButton } from '../../../common/customButton/customButton';
import { CustomSpinner, Small } from '../../../common/index';
import { handleChangeValue, handleSubmit, AccountSettingHeaders, handleApplyAll } from '../../component/index';
import { Heading } from '../../../common';
import { VendorHeader } from '../index.js';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import BlockTimeModal from './BlockTimeModal.jsx';
import BlockTimeSection from './BlockTimeSection.jsx';

const format = 'HH:mm';
const OpeningHoursPolicie = ({
  isLoader,
  openingHourseFormValue,
  setOpeningHourseFormValue,
  deletionRequest,
  applyAll,
  setApplyAll,
  applyDisable,
  setApplyDisable,
  addressFormValue,
  handleChangeTime
}) => {
  const { t } = Locale();
  const [value, setValue] = useState();
  const [day, setDay] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [err, setErr] = useState({});
  const language = localStorage.getItem('i18nextLng');
  const [thaiDay, setThaiDay] = useState();
  const [previousBusinessHours, setPreviousBusinessHours] = useState();
  const [openBlockTimeModal, setOpenBlockTimeModal] = useState(false);
  const [selectedBlockSlots, setSelectedBlockSlots] = useState(null)
  useEffect(() => {
    let changeDay = [
      t('vendor.Monday'),
      t('vendor.Tuesday'),
      t('vendor.Wednesday'),
      t('vendor.Thursday'),
      t('vendor.Friday'),
      t('vendor.Saturday'),
      t('vendor.Sunday'),
    ];
    let newDay = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ];
    let newValue = [
      '00:00',
      '00:30',
      '01:00',
      '01:30',
      '02:00',
      '02:30',
      '03:00',
      '03:30',
      '04:00',
      '04:30',
      '05:00',
      '05:30',
      '06:00',
      '06:30',
      '07:00',
      '07:30',
      '08:00',
      '08:30',
      '09:00',
      '09:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00',
      '15:30',
      '16:00',
      '16:30',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
      '21:30',
      '22:00',
      '22:30',
      '23:00',
      '23:30',
      '24:00',
    ];

    setValue(newValue);
    setDay(newDay);
    setThaiDay(changeDay);
  }, [language, t]);

  const { bussiness_hours, breakTime } = {
    openingHourseFormValue,
  };


  useEffect(() => {
    getDisableBreakStartTime();
  }, [openingHourseFormValue?.bussiness_hours])


  const getMinOpenAndMaxClose = () => {
    let minOpen = 24 * 60; // in minutes
    let maxClose = 0; // in minutes

    const businessHours = openingHourseFormValue?.bussiness_hours;

    if (!businessHours || typeof businessHours !== 'object') {
      return {
        minOpenHour: 0,
        minOpenMinute: 0,
        maxCloseHour: 0,
        maxCloseMinute: 0,
      };
    }

    Object.values(businessHours).forEach((item) => {
      if (!item || typeof item !== 'object') return;

      const { open, close, shop_open } = item;

      if (shop_open !== "true" && shop_open !== true) return;
      if (!open || !close) return;

      const [openHour, openMin] = open.split(':').map(Number);
      const [closeHour, closeMin] = close.split(':').map(Number);

      if (
        isNaN(openHour) || isNaN(openMin) ||
        isNaN(closeHour) || isNaN(closeMin)
      ) return;

      const openTotal = openHour * 60 + openMin;
      const closeTotal = closeHour * 60 + closeMin;

      if (openTotal < minOpen) minOpen = openTotal;
      if (closeTotal > maxClose) maxClose = closeTotal;
    });

    return {
      minOpenHour: Math.floor(minOpen / 60),
      minOpenMinute: minOpen % 60,
      maxCloseHour: Math.floor(maxClose / 60),
      maxCloseMinute: maxClose % 60,
    };
  };


  const getDisableBreakStartTime = () => {

    const { minOpenHour, minOpenMinute, maxCloseHour, maxCloseMinute } = getMinOpenAndMaxClose();

    // 10 minutes before closing
    const latestHour = maxCloseMinute >= 10 ? maxCloseHour : maxCloseHour - 1;
    const latestMinute = maxCloseMinute >= 10 ? maxCloseMinute - 10 : 50;

    return {
      disabledHours: () => {
        const disabled = [];
        for (let i = 0; i < 24; i++) {
          if (i < minOpenHour || i > latestHour) disabled.push(i);
        }
        return disabled;
      },
      disabledMinutes: (selectedHour) => {
        if (selectedHour === minOpenHour) {
          return Array.from({ length: minOpenMinute }, (_, i) => i);
        }
        if (selectedHour === latestHour) {
          return Array.from({ length: 60 - latestMinute - 1 }, (_, i) => latestMinute + 1 + i);
        }
        return [];
      }
    };
  };

  const getDisableBreakEndTime = (startTime) => {
    const { maxCloseHour, maxCloseMinute } = getMinOpenAndMaxClose(); // make sure this returns correct values
    const start = dayjs(startTime, 'HH:mm');
    const startHour = start.hour();
    const startMinute = start.minute();

    return {
      disabledHours: () => {
        const disabled = [];
        for (let i = 0; i < startHour; i++) {
          disabled.push(i);
        }
        for (let i = maxCloseHour + 1; i < 24; i++) {
          disabled.push(i);
        }
        return disabled;
      },

      disabledMinutes: (selectedHour) => {
        if (selectedHour === startHour) {
          // Disable 0 to startMinute (inclusive)
          return Array.from({ length: startMinute + 1 }, (_, i) => i);
        }

        if (selectedHour === maxCloseHour) {
          // Disable minutes after max close time
          return Array.from({ length: 60 - maxCloseMinute }, (_, i) => maxCloseMinute + i);
        }

        return [];
      }
    };
  };

  const handleEdit = (item) => {
    setSelectedBlockSlots(item);
    setOpenBlockTimeModal(true)
  };

  return (
    <>
      <BlockTimeModal
        setOpeningHourseFormValue={setOpeningHourseFormValue}
        setShowModal={setOpenBlockTimeModal}
        setSelectedBlockSlots={setSelectedBlockSlots}
        showModal={openBlockTimeModal}
        openingHourseFormValue={openingHourseFormValue}
        selectedBlockSlots={selectedBlockSlots}
      />
      <div className={`heading-outer-div  ${deletionRequest && 'vendor-deletionRequest-user-header'}`}>
        <VendorHeader />
        <Heading text={t('vendor.accountSetting')} icon={'bi bi-shop-window'} />
        <div className="after-heading-outer-div">
          <div className="user-common-box">
            <div className="user-common-box-inner">
              <div className="user-common-box-fix-content row-box m-0 mb-3">
                <AccountSettingHeaders />
              </div>
              <div className="container-fluid mt-2 user-inner-content-scrollar user-inner-content-scrollar-after-fix-content">
                <div className="OpeningHoursPolicies_BuisnesHourOuterDiv p-2">
                  <h5 className="mt-2 opening-hours-outer-heading">
                    {t('vendor.bussinessHours')}
                  </h5>
                  <div className="row ">
                    <div className="opening-hourse-p-tag">
                      {t('vendor.note')}
                    </div>
                    <Small name={bussiness_hours} err={err.bussiness_hours} />
                  </div>
                  <div className='opening-hourse-apply-all-section mt-2'>
                    <div class="form-check " >
                      <input
                        onChange={(e) => handleApplyAll(e, setApplyAll, openingHourseFormValue, setOpeningHourseFormValue, previousBusinessHours, setPreviousBusinessHours)}
                        class="form-check-input openingHourse-day-checkbox"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                        checked={applyAll}
                        disabled={applyDisable}
                      />
                      <label class="mt-1 fw-bold openign-hourse-span-current-day cursor-point-class apply-all-label" for="flexCheckDefault">
                        {t('vendor.applyAll')}
                      </label>
                    </div>
                  </div>
                  <div className=" OpeningHoursPolicies_DayWise_Time">
                    {day &&
                      day.length >= 0 &&
                      day.map((currentDay, key) => (
                        <div
                          className="row mt-2 opening-hourse-buisssnes-hourse-outer-row"
                          key={key}
                        >
                          <div className="col-4 openingHourseDayDiv mt-2">
                            <input
                              type="checkbox"
                              className="form-check-input openingHourse-day-checkbox"
                              id={`myCheckbox-${currentDay}`}
                              name={`bussiness_hours[${currentDay.toLowerCase()}].shop_open`}
                              checked={
                                openingHourseFormValue.bussiness_hours?.[
                                currentDay.toLowerCase()
                                ]?.['shop_open'] === 'true' ||
                                openingHourseFormValue.bussiness_hours?.[
                                currentDay.toLowerCase()
                                ]?.['shop_open'] === true
                              }
                              onChange={(e) =>
                                handleChangeValue(
                                  e,
                                  setOpeningHourseFormValue,
                                  '',
                                  '',
                                  setErr,
                                  setApplyDisable
                                )
                              }
                            />
                            <span
                              className="openign-hourse-span-current-day cursor-point-class"
                              onClick={() => {
                                const currentValue =
                                  openingHourseFormValue.bussiness_hours?.[
                                  currentDay.toLowerCase()
                                  ]?.['shop_open'];
                                setOpeningHourseFormValue((prevState) => ({
                                  ...prevState,
                                  bussiness_hours: {
                                    ...prevState?.bussiness_hours,
                                    [currentDay.toLowerCase()]: {
                                      ...prevState?.bussiness_hours?.[
                                      currentDay?.toLowerCase()
                                      ],
                                      shop_open: !currentValue,
                                    },
                                  },
                                }));
                              }}
                            >
                              {thaiDay[key]}
                            </span>
                          </div>
                          <div
                            className={'col-3 a vendor-opening-horse-open-time'}
                          >

                            <Select
                              className="opening-hours-select-tag-open"
                              placeholder={t('header.select')}
                              disabled={
                                (openingHourseFormValue.bussiness_hours &&
                                  openingHourseFormValue.bussiness_hours[
                                    currentDay.toLowerCase()
                                  ]?.shop_open === 'true') ||
                                  openingHourseFormValue.bussiness_hours?.[
                                    currentDay.toLowerCase()
                                  ]?.shop_open === true
                                  ? false
                                  : true
                              }
                              value={
                                openingHourseFormValue?.bussiness_hours &&
                                  openingHourseFormValue?.bussiness_hours[
                                    currentDay?.toLowerCase()
                                  ]?.open ? openingHourseFormValue?.bussiness_hours[
                                    currentDay?.toLowerCase()
                                  ]?.open : null
                              }
                              onChange={(value) =>
                                handleChangeValue(
                                  {
                                    target: {
                                      name: `bussiness_hours[${currentDay.toLowerCase()}].open`,
                                      value,
                                    },
                                  },
                                  setOpeningHourseFormValue,
                                  '',
                                  openingHourseFormValue,
                                  setErr,
                                  setApplyDisable
                                )
                              }
                            >
                              {value.map((item) => (
                                <Select.Option key={item} value={item}>
                                  {item}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                          <div className="col-2 a opening-hourse-to-div text-center">
                            {t('vendor.to')}
                          </div>
                          <div className="col-3 a vendor-opening-horse-close-time">
                            <Select
                              className="opening-hours-select-tag-open"
                              disabled={
                                (openingHourseFormValue.bussiness_hours &&
                                  openingHourseFormValue.bussiness_hours[
                                    currentDay.toLowerCase()
                                  ]?.shop_open === 'true') ||
                                  openingHourseFormValue.bussiness_hours?.[
                                    currentDay.toLowerCase()
                                  ]?.shop_open === true
                                  ? false
                                  : true
                              }
                              value={
                                openingHourseFormValue.bussiness_hours &&
                                  openingHourseFormValue.bussiness_hours[
                                    currentDay.toLowerCase()
                                  ]?.close ? openingHourseFormValue.bussiness_hours[
                                    currentDay.toLowerCase()
                                  ]?.close : null
                              }
                              onChange={(value) =>
                                handleChangeValue(
                                  {
                                    target: {
                                      name: `bussiness_hours[${currentDay.toLowerCase()}].close`,
                                      value,
                                    },
                                  },
                                  setOpeningHourseFormValue,
                                  '',
                                  '',
                                  setErr,
                                  setApplyDisable
                                )
                              }
                              placeholder={t('header.select')}
                            >
                              {value
                                .filter(
                                  (item) =>
                                    openingHourseFormValue &&
                                    openingHourseFormValue?.bussiness_hours &&
                                    item >
                                    openingHourseFormValue?.bussiness_hours[
                                      currentDay.toLowerCase()
                                    ]?.open,
                                )
                                .map((item) => (
                                  <Select.Option key={item} value={item}>
                                    {item}
                                  </Select.Option>
                                ))
                              }

                            </Select>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="OpeningHoursPolicies_service_my_loacationDiv checkbox-outer mt-4">
                    <div className="row">
                      <div className="col-lg-3 col-md-12">
                        <div className="row">
                          <div className="col-1">
                            <input
                              type="checkbox"
                              className="form-check-input openingHourse-day-checkbox"
                              id="myCheckboxServiceMyLocaton"
                              name="serviceMyLocation"
                              checked={openingHourseFormValue.serviceMyLocation}
                              onChange={(e) =>
                                handleChangeValue(
                                  e,
                                  setOpeningHourseFormValue,
                                  '',
                                  '',
                                  setErr,
                                )
                              }
                            />
                          </div>
                          <div className="col-10 ms-2 d-flex align-items-center">
                            <label
                              htmlFor="myCheckboxServiceMyLocaton"
                              className="vendor-opening-hours-p-tag-inner cursor-pointer"
                            >
                              {t('vendor.offerServiceMy')}
                            </label>
                          </div>
                        </div>
                        <Small
                          name={'serviceLocation'}
                          err={err.serviceLocation}
                        />
                      </div>
                      <div className="col-lg-4 col-md-12 custom-width-60">

                        <div className="row">
                          <div className="col-1">
                            <input
                              type="checkbox"
                              className="form-check-input openingHourse-day-checkbox"
                              id="myCheckboxServiceCustomer"
                              name="serviceCustomerLocation"
                              checked={
                                openingHourseFormValue.serviceCustomerLocation
                              }
                              onChange={(e) =>
                                handleChangeValue(
                                  e,
                                  setOpeningHourseFormValue,
                                  '',
                                  '',
                                  setErr,
                                )
                              }
                            />
                          </div>
                          <div className="col-11 ">
                            <label
                              htmlFor="myCheckboxServiceCustomer"
                              className="vendor-opening-hours-p-tag-inner cursor-pointer"
                            >
                              {t('vendor.offerServiceCustomer')}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-12">
                        <div className="row">
                          <div className="col-lg-4  col-md-2 col-sm-3  vendor-opening-hours-p-tag-inner-div">
                            <p className="vendor-opening-hours-p-tag-inner">
                              {t('vendorField.breakTime')}
                            </p>
                          </div>
                          <div className='col-3'>
                            <TimePicker
                              name="breakStartTime"
                              format={format}
                              value={dayjs(((openingHourseFormValue?.breakTime?.start_time && openingHourseFormValue?.breakTime?.start_time !== 'undefined') ? openingHourseFormValue?.breakTime?.start_time : '00:00'), format)}
                              onChange={(value) => handleChangeTime(value, 'start_time')}
                              disabledTime={() => getDisableBreakStartTime()}
                            />
                          </div>
                          <div className='col-1'>
                            To
                          </div>
                          <div className='col-3'>
                            <TimePicker
                              name="breakEndTime"
                              format={format}
                              value={dayjs(((openingHourseFormValue?.breakTime?.end_time && openingHourseFormValue?.breakTime?.end_time !== 'undefined') ? openingHourseFormValue?.breakTime?.end_time : '00:00'), format)}
                              onChange={(value) => handleChangeTime(value, 'end_time')}
                              showNow={false}
                              minuteStep={1}
                              disabledTime={() => getDisableBreakEndTime(openingHourseFormValue?.breakTime?.start_time)}
                            />
                          </div>
                        </div>
                        <Small name={breakTime} err={err.breakTime} />
                      </div>
                    </div>
                  </div>
                  <BlockTimeSection
                    handleEdit={handleEdit}
                    openingHourseFormValue={openingHourseFormValue}
                    setOpeningHourseFormValue={setOpeningHourseFormValue}
                  />
                  <div className="OpeningHoursPolicies_Must_cancel_days_before_scheduled mt-5"></div>
                  <div className="mt-5 mb-1 opening-hours-btn-section">
                    <button type="button" onClick={() => setOpenBlockTimeModal(true)} class="btn btn-secondary block-time-btn">Add Block Time</button>
                    <CustomButton
                      className="btn save-btn"
                      name={t('button.saveButton')}
                      onClick={handleSubmit}
                      formValue={openingHourseFormValue}
                      setErr={setErr}
                      formType="openingHourse"
                      disabled={buttonDisabled}
                      setButtonDisabled={setButtonDisabled}
                      t={t}
                      addressFormValue={addressFormValue}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoader && (
        <>
          <CustomSpinner />
        </>
      )}

    </>
  );
};
OpeningHoursPolicie.propTypes = {
  openingHourseFormValue: PropTypes.shape({
    bussiness_hours: PropTypes.object,
    breakTime: PropTypes.string,
    cancellationPolicy: PropTypes.number,
    paymentOption: PropTypes.bool,
    serviceMyLocation: PropTypes.bool,
    serviceCustomerLocation: PropTypes.bool,
    cash_payment: PropTypes.bool,
    pay_online: PropTypes.bool,
  }),
  setOpeningHourseFormValue: PropTypes.func,
};

export default OpeningHoursPolicie;